import React from 'react';
import classNames from 'classnames';

// Types
import { FlexItemProps, FlexProps } from '../../types/layout/flex';

export const Flex = ({
  wrap,
  width,
  border,
  shadow,
  height,
  columns,
  stretch,
  addBlock,
  children,
  vertical,
  bgColour,
  rounding,
  className,
  fontColour,
  horizontal,
  whitespace,
  borderColour,
}: FlexProps) => (
  <div
    className={classNames('flex', {
      'p-block': addBlock,
      [`${width}`]: width,
      [`${shadow}`]: shadow,
      [`${bgColour}`]: bgColour,
      [`${rounding}`]: rounding,
      [`${className}`]: className,
      [`${fontColour}`]: fontColour,
      [`${borderColour}`]: borderColour,

      'flex-wrap': wrap,
      'flex-col': columns,
      [`${height}`]: height,
      [`${vertical}`]: vertical,
      [`${className}`]: className,
      [`${horizontal}`]: horizontal,
      [`${whitespace}`]: whitespace,
      'flex-grow-auto': stretch && stretch === 'auto',
      'flex-grow-equal': stretch && stretch === 'equal',

      [`${border?.top}`]: border?.top,
      [`${border?.left}`]: border?.left,
      [`${border?.right}`]: border?.right,
      [`${border?.bottom}`]: border?.bottom,
      [`${border?.standard}`]: border?.standard,
    })}
  >
    {children}
  </div>
);

export const FlexItem = ({
  grow,
  width,
  border,
  shadow,
  addBlock,
  children,
  bgColour,
  rounding,
  className,
  fontColour,
  borderColour,
}: FlexItemProps) => (
  <div
    className={classNames('flex', {
      'flex-grow': grow,
      'p-block': addBlock,
      [`${width}`]: width,
      [`${shadow}`]: shadow,
      [`${bgColour}`]: bgColour,
      [`${rounding}`]: rounding,
      [`${className}`]: className,
      [`${fontColour}`]: fontColour,
      [`${borderColour}`]: borderColour,

      [`${border?.top}`]: border?.top,
      [`${border?.left}`]: border?.left,
      [`${border?.right}`]: border?.right,
      [`${border?.bottom}`]: border?.bottom,
      [`${border?.standard}`]: border?.standard,
    })}
  >
    {children}
  </div>
);
